module.exports = __webpack_public_path__ + "14915f9ec9d70d4187464c953956278f.svg";